<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  mounted() {
    // 初始化设备类型
    const cachedIsMobile = JSON.parse(window.localStorage.getItem('isMobile') || 'false');
    this.isMobile = cachedIsMobile || this.cacheDeviceType();

    // if(this.isMobile){
    //   this.toH5();
    // }

    // window.onbeforeunload = ()=>{
    //   window.localStorage.removeItem('isInit');
    // }
  },
  methods:{
     // 跳转到h5
    toH5(){
      window.location.href = 'https://web.baipubang.com/h5';
    },
    // 判断是否为移动设备
    isMobileDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = [
        'android',
        'iphone',
        'ipad',
        'mobile',
        'windows phone',
        'blackberry',
        'nokia',
        'opera mini',
        'samsung',
        'htc',
        'lg',
        'sony',
        'motorola',
        'mobi',
      ];
      return mobileKeywords.some(keyword => userAgent.includes(keyword));
    },
    // 缓存设备类型
    cacheDeviceType() {
      const isMobile = this.isMobileDevice();
      window.localStorage.setItem('isMobile', isMobile); // 使用 localStorage 缓存
      return isMobile;
    },
  }
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color:rgba(56, 56, 56);
}
</style>
